import { Link } from "react-router-dom";
import { Youtube, Instagram, Twitter, Music2, Mail } from "lucide-react";
import { LOGO, SOCIAL } from "../data/content";

export default function Footer() {
  const links = [
    { href: SOCIAL.tiktok, label: "TikTok", icon: Music2 },
    { href: SOCIAL.instagram, label: "Instagram", icon: Instagram },
    { href: SOCIAL.x, label: "X", icon: Twitter },
    { href: SOCIAL.youtube, label: "YouTube", icon: Youtube },
  ];
  return (
    <footer className="border-t border-white/10 bg-[#0A0A0E]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-12 grid gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <img src={LOGO} alt="Laugh at L.A. logo" className="h-12 w-12 object-contain" />
            <div className="font-display text-2xl text-white">LAUGH <span className="text-[#E11D48]">@</span> L.A.</div>
          </div>
          <p className="mt-4 text-sm text-gray-400 leading-relaxed">
            A Providence Film Group comedy series hosted by Todd Bridges. Live L.A. stand-up and original scripted sketches, in front of a live audience.
          </p>
        </div>
        <div>
          <h3 className="text-xs font-semibold uppercase tracking-widest text-[#F59E0B]">Follow the show</h3>
          <div className="mt-4 flex gap-3">
            {links.map((l) => (
              <a key={l.label} href={l.href} target="_blank" rel="noopener noreferrer" aria-label={l.label} data-testid={`footer-social-${l.label.toLowerCase()}`}
                className="rounded-full border border-white/15 p-2.5 text-gray-300 transition-colors hover:border-[#F59E0B] hover:text-[#F59E0B]">
                <l.icon size={18} />
              </a>
            ))}
            <a href={SOCIAL.imdb} target="_blank" rel="noopener noreferrer" data-testid="footer-social-imdb"
              className="rounded-full border border-white/15 px-3 py-2.5 text-xs font-bold text-gray-300 transition-colors hover:border-[#F59E0B] hover:text-[#F59E0B]">
              IMDb
            </a>
          </div>
          <div className="mt-6 space-y-2 text-sm">
            <a href={`mailto:${SOCIAL.emailShow}`} className="flex items-center gap-2 text-gray-300 hover:text-white" data-testid="footer-email-show">
              <Mail size={14} /> {SOCIAL.emailShow}
            </a>
            <a href={`mailto:${SOCIAL.emailPfg}`} className="flex items-center gap-2 text-gray-300 hover:text-white" data-testid="footer-email-pfg">
              <Mail size={14} /> {SOCIAL.emailPfg}
            </a>
          </div>
        </div>
        <div>
          <h3 className="text-xs font-semibold uppercase tracking-widest text-[#F59E0B]">Site</h3>
          <div className="mt-4 grid grid-cols-2 gap-2 text-sm">
            <Link to="/show" className="text-gray-300 hover:text-white" data-testid="footer-link-show">The Show</Link>
            <Link to="/cast" className="text-gray-300 hover:text-white" data-testid="footer-link-cast">Cast</Link>
            <Link to="/sketches" className="text-gray-300 hover:text-white" data-testid="footer-link-sketches">Sketches</Link>
            <Link to="/industry" className="text-gray-300 hover:text-white" data-testid="footer-link-industry">Licensing & Partnerships</Link>
            <Link to="/privacy" className="text-gray-300 hover:text-white" data-testid="footer-link-privacy">Privacy</Link>
            <Link to="/accessibility" className="text-gray-300 hover:text-white" data-testid="footer-link-accessibility">Accessibility</Link>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-gray-500">
        © {new Date().getFullYear()} Providence Film Group. Laugh at L.A. All rights reserved.
      </div>
    </footer>
  );
}
